import { render } from "./AiReports.vue?vue&type=template&id=f0dfdcda&scoped=true"
import script from "./AiReports.vue?vue&type=script&lang=js"
export * from "./AiReports.vue?vue&type=script&lang=js"

import "./AiReports.vue?vue&type=style&index=0&id=f0dfdcda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0dfdcda"],['__file',"src/views/Reports/Agent/AiReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0dfdcda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0dfdcda', __exports__)) {
    api.reload('f0dfdcda', __exports__)
  }
  
  module.hot.accept("./AiReports.vue?vue&type=template&id=f0dfdcda&scoped=true", () => {
    api.rerender('f0dfdcda', render)
  })

}


export default __exports__